<template>
	<div
		class="modal-title modal-title-sticky padding-bottom-xs-1"
		v-if="ui.calendarViewType == 'week'"
	>
		<div class="col-xs-12">
			<h3
				class="
					margin-bottom-xs-1
					padding-bottom-xs-1
					menu-item-lined
					no-line-top
					capitalize
				"
			>
				{{ activities.selected.activity_name }}
				<span class="modal-activity-date">
					{{ dates.active.monthName }} {{ year }}, Vecka
					{{ dates.active.week }}
				</span>
			</h3>
			<a
				href="#"
				class="modal-close link-close-right"
				@click.prevent="setModalState(0)"
			></a>

			<div class="booking-week-nav-actions booking-week-nav-actions--mobile-full">
				<ShowNextAvailableTimeButton />
			</div>

			<div class="modal-title-arrows row">
				<div class="col-xs-4">
					<a
						href="#"
						class="link-arrow-left"
						@click.prevent="setupActiveDates('back')"
						v-if="!dateIsInThePast"
						>v. {{ dates.active.previousWeek }}</a
					>
				</div>
				<div
					class="
						col-xs-4
						padding-left-xs-0 padding-right-xs-0
						text-center
					"
				>
					<p class="margin-bottom-xs-0 modal-active-week">
						<strong>Vecka {{ dates.active.week }}</strong>
					</p>
				</div>
				<div class="col-xs-4 text-align-right-xs">
					<a
						href="#"
						class="link-arrow-right"
						@click.prevent="setupActiveDates('forward')"
						>v. {{ dates.active.nextWeek }}</a
					>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ProviderAndCalendarNavMobile from "./ProviderAndCalendarNavMobile.vue";
import BookingCalendarMonth from "./BookingCalendarMonth.vue";
import BookingCalendarWeekMobile from "./BookingCalendarWeekMobile.vue";
import ShowNextAvailableTimeButton from "./ShowNextAvailableTimeButton.vue";

export default {
	components: {
		ProviderAndCalendarNavMobile,
		BookingCalendarMonth,
		BookingCalendarWeekMobile,
		ShowNextAvailableTimeButton,
	},
	computed: {
		...mapState([
			"activityGroups",
			"activities",
			"providers",
			"selectedSlot",
			"dates",
			"ui",
			"booking",
			"patient",
		]),
		...mapGetters([
			"dateIsInThePast",
			"activityIsCampaign",
			"formatProviderName",
			"selectedSlotFormated",
			"formIsValid",
			"noAvailableTimesForWeek",
		]),
		year() {
			if (this.dates.active.niceDate) {
				return this.dates.active.niceDate.substring(0, 4);
			}
			return this.dates.active.year;
		},
	},
	methods: {
		...mapActions([
			"setActivityGroup",
			"setActivity",
			"setupActiveDates",
			"setSelectedSlot",
			"setProvider",
			"getRealWeekday",
			"setModalState",
			"handleSwipe",
			"shouldDeselectTimeslot",
		]),
	},
};
</script>